import React, { useMemo } from 'react'
import useI18n from '../../../i18n/useI18n'
import { formatNumber } from '../utils'

const ApplicationsTrendCard = ({ data = [], loading }) => {
  const { t } = useI18n()

  const { points, maxValue, total } = useMemo(() => {
    if (!data || !data.length) {
      return {
        points: '',
        maxValue: 0,
        total: 0
      }
    }

    const height = 120
    const width = Math.max(data.length - 1, 1) * 40
    const max = data.reduce((maxSoFar, item) => Math.max(maxSoFar, Number(item.count || 0)), 0)
    const normalizedPoints = data.map((item, index) => {
      const x = data.length === 1 ? width / 2 : (width / (data.length - 1)) * index
      const ratio = max > 0 ? Number(item.count || 0) / max : 0
      const y = height - ratio * height
      return `${x},${y}`
    }).join(' ')

    const totalCount = data.reduce((sum, item) => sum + Number(item.count || 0), 0)

    return {
      points: normalizedPoints,
      maxValue: max,
      total: totalCount,
      viewBox: `0 0 ${width} ${height}`
    }
  }, [data])

  return (
    <div className="card dashboard-card">
      <div className="header">
        <h2><strong>{t('DASHBOARD_CARD_TREND_TITLE')}</strong></h2>
      </div>
      <div className="body">
        {loading && !data.length && (
          <div className="skeleton-chart"></div>
        )}
        {!loading && !data.length && (
          <div className="empty-state">{t('DASHBOARD_CARD_EMPTY_STATE')}</div>
        )}
        {data.length > 0 && (
          <>
            <div className="trend-meta">
              <div>
                <p>{t('DASHBOARD_CARD_TREND_TOTAL')}</p>
                <h3>{formatNumber(total)}</h3>
              </div>
              <div>
                <p>{t('DASHBOARD_CARD_TREND_PEAK')}</p>
                <h3>{formatNumber(maxValue)}</h3>
              </div>
            </div>
            <div className="trend-chart">
              <svg viewBox={`0 0 ${Math.max(data.length - 1, 1) * 40} 120`} preserveAspectRatio="none">
                <polyline
                  fill="none"
                  stroke="#4caf50"
                  strokeWidth="3"
                  strokeLinejoin="round"
                  strokeLinecap="round"
                  points={points}
                />
                <polyline
                  fill="rgba(76, 175, 80, 0.15)"
                  stroke="none"
                  points={`${points} ${Math.max(data.length - 1, 1) * 40},120 0,120`}
                />
              </svg>
            </div>
            <div className="trend-legend">
              {data.map((item) => (
                <div className="trend-legend-item" key={item.date}>
                  <span className="date">{item.date}</span>
                  <span className="count">{formatNumber(item.count)}</span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default ApplicationsTrendCard

